import React from 'react';

interface DisplayProps {
  text: string;
  gameOver?: boolean;
}

// Display for score, rows, level, and game over
const Display: React.FC<DisplayProps> = ({ text, gameOver }) => (
  <div
    style={{
      color: gameOver ? 'red' : 'white',
      fontSize: '1rem',
      margin: '0.5rem 0',
    }}
  >
    {text}
  </div>
);

export default React.memo(Display);